import { useSelector } from 'react-redux';
import { Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { selectChangePlan } from '@app/redux/changePlan';

import OrderDetailsSection from '../OrderDetailsSection';

const Contract = () => {
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview',
  });

  const {
    cart: {
      cartItems: { plan },
    },
  } = useSelector(selectChangePlan);

  const contractTypeDetails = plan?.contractTerms?.includes('24')
    ? t('satelliteMigrationDetails.contract.24MonthContractDetails')
    : t('satelliteMigrationDetails.contract.monthToMonthContractDetails');

  const contractContent = plan?.contractTerms ? contractTypeDetails : t('details.contract.content');

  const badgeText = plan?.contractTerms ? (plan?.contractTerms || '').replace(' contract', '') : undefined;

  return (
    <OrderDetailsSection id="contract" badge={badgeText} title={t('details.contract.title')}>
      <Txt variant="bodySmallRegular">{contractContent}</Txt>
    </OrderDetailsSection>
  );
};

export default Contract;
